export var defaultProps = {
    className: '',
    contentType: 'inputStyle',
    defaultChecked: false,
    disabled: false,
    indeterminate: false,
    onChange: function (e) { },
};
export var defaultGroupProps = {
    className: '',
    options: [],
    value: [],
    onChange: function (parmas) { },
};
